import * as React from 'react'
import { Wrapper } from './style'

const NoDataFound2 = ({ size='small', heading, description, align='right' }) => {
  return (
    <Wrapper className={`noDataFound ${size} ${align}`}>
      {heading && <b>{heading}</b>}
      {description && <p>{description}</p>}
    </Wrapper>
  )
}
export default NoDataFound2
